import classNames from 'classnames'
import { RefObject } from 'react'

import { Nullable } from 'cng-common/models/utils'

import styles from './ScrollButton.module.scss'

interface IScrollButton {
  direction: 'right' | 'left'
  rootRef: RefObject<Nullable<HTMLDivElement>>
  type: 'hidden' | 'active' | 'inactive'
}

const MIN_SCROLL_WIDTH = 300

export const ScrollButton = ({ rootRef, direction, type }: IScrollButton) => {
  if (type === 'hidden') {
    return <></>
  }

  return (
    <div
      className={classNames(styles.scrollButtons, styles[type])}
      onClick={() => {
        if (rootRef.current) {
          const { clientWidth } = rootRef.current
          const widthDelta = Math.max(clientWidth / 2, MIN_SCROLL_WIDTH)
          const directionDelta = direction === 'right' ? 1 : -1
          rootRef.current.scrollLeft += widthDelta * directionDelta
        }
      }}
    >
      <div className={`kbase kbase-omni-arrows-${direction}`}></div>
    </div>
  )
}
